import React from 'react';
import { useSelector } from 'react-redux';

import { Button, Col, Modal, Row } from 'antd';

import AlertOptimizerModalHeader from './AlertOptimizerModalHeader';
import CloseIcon from '../../../resources/icons/CloseIcon';
import { selectDarkMode } from '../../../userBrowserSettings/store/browserSettings.selectors';
import { getThemeColorClass } from '../../../utils/helpers/themeHelpers';

const classes = {
    actionsWrapper: 'actions-wrapper',
    modalWrapper: 'duplicate-optimizer-modal-wrapper',
};
const COLUMN_SIZE = 30;

const AiOptimizerInProgressModal = ({
    title = 'AI Optimizer In Progress',
    optimizerData,
    locationObject,
    isOpen,
    handleClose,
}) => {
    const darkMode = useSelector(selectDarkMode);

    return (
        <Modal
            centered
            forceRender
            open={isOpen}
            title={
                <AlertOptimizerModalHeader
                    title={title}
                    optimizerData={optimizerData}
                    locationObject={locationObject}
                />
            }
            onCancel={handleClose}
            footer={null}
            closeIcon={<CloseIcon />}
            wrapClassName={`${classes.modalWrapper} ${getThemeColorClass(darkMode)}`}
        >
            <Row wrap={false} justify='center' align='top'>
                <Col flex={`${COLUMN_SIZE}px`}></Col>
                <Col flex='auto'>
                    <div>
                        You can only run&nbsp;
                        <span className='fw-700'>one AI Optimizer</span>&nbsp;at a time.
                    </div>
                    <div>Please wait for the current one to finish before running another.</div>
                </Col>
            </Row>
            <div className={classes.actionsWrapper}>
                <Button onClick={handleClose} type='primary'>
                    OK
                </Button>
            </div>
        </Modal>
    );
};

export default AiOptimizerInProgressModal;
